import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IEmailTemplateVars } from '../../../interfaces/IEmailNotification';
import { phoneValidator } from '../../../validators/phone/phone.validator';
import { emailValidator } from '../../../validators/email/email.validator';
import { SELECTED_CONTRACT_DATA } from '../../../utils/constants';
import { VivrService } from '../../../services/vivr/vivr.service';
import { FormatPhonePipe } from '../../shared/pipes/format-phone.pipe';
import { Subject } from 'rxjs';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { MessagesService } from '../../../services/messages/messages.service';
import { IMessage } from '../../../services/messages/messages.interface';
import { DataService } from '../../../services/data/data.service';
import { SUBMIT_LEAD } from '../../../services/ga4/ga4.constant';
import { IContractData } from '../../../interfaces/IJob';
import { Router } from '@angular/router';
declare const window: any;

@Component({
  selector: 'app-special-member-offer-form',
  templateUrl: './special-member-offer-form.component.html',
  styleUrls: ['./special-member-offer-form.component.scss']
})
export class SpecialMemberOfferFormComponent implements OnInit, OnDestroy {
  specialOfferForm!: FormGroup;
  isSubmitForm: boolean = false;
  formSubmitted: boolean = false;

  // Variables for template
  firstName: string = '';
  lastName: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zip: string = '';
  cleaner$ = new Subject<void>();
  private contractData: IContractData | null = null;
  isSpecialMemberOfferFormUrl = false;

  constructor(
    private fb: FormBuilder,
    private vivr: VivrService,
    private formatPhonePipe: FormatPhonePipe,
    private gaService: Ga4Service,
    private messageService: MessagesService,
    private data: DataService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.parseContractData();
    this.initializeForm();
    this.loadContractData();
    this.isSpecialMemberOfferFormUrl = this.router.url.startsWith('/special-member-offer-form-v2');
  }

  private parseContractData(): void {
    const stored = sessionStorage.getItem(SELECTED_CONTRACT_DATA);
    if (stored) {
      try {
        this.contractData = JSON.parse(stored);
      } catch {
        this.contractData = null;
      }
    }
  }

  initializeForm(): void {
    let phone = null;
    let email = null;
    if (this.contractData) {
      phone = this.contractData?.baseContract?.primaryCustomerPhone?.phoneNumber || null;
      email = this.contractData?.baseContract?.primaryCustomerEmail || null;
    }
    this.specialOfferForm = this.fb.group({
      phone: [phone, [Validators.required, phoneValidator()]],
      email: [email, [Validators.required, emailValidator()]]
    });
  }

  loadContractData(): void {
    if (this.contractData) {
      this.firstName = this.contractData?.baseContract?.primaryCustomer?.firstName || '';
      this.lastName = this.contractData?.baseContract?.primaryCustomer?.lastName || '';
      this.address = this.contractData?.baseContract?.propertyAddress?.addressLine1 || '';
      this.city = this.contractData?.baseContract?.propertyAddress?.city || '';
      this.state = this.contractData?.baseContract?.propertyAddress?.state || '';
      this.zip = this.contractData?.baseContract?.propertyAddress?.zip || '';
    }
  }

  onSubmit(form: FormGroup): void {
    this.isSubmitForm = true;
    if (form.valid) {
      const templateVars: IEmailTemplateVars = {
        firstName: this.firstName,
        lastName: this.lastName,
        emailId: form.value.email,
        phoneNumber: this.formatPhonePipe.transform(form.value.phone),
        address: `${this.address}${this.city ? ', ' + this.city : ''}${this.state ? ', ' + this.state : ''}${this.zip ? ', ' + this.zip : ''}`
      };
      this.vivr.sendEmailNotification(templateVars).subscribe({
        next: () => {
          this.gaService.setGa4DtcSearsLanding(SUBMIT_LEAD, this.contractData?.baseContract?.clientId ?? 'Unknown Client');

          // Track the form submission success action in Optimizely
          try {
            if (window.optimizely) {
              window.optimizely.push({
                type: 'event',
                eventName: 'cross_sell_form_success'
              });
            }
          } catch (error) {
            console.warn('[Optimizely] Error tracking form success:', error);
          }

          this.isSubmitForm = false;
          this.formSubmitted = true;
        },
        error: () => {
          const errorMessage: IMessage = {
            severity: 'error',
            text: `We’re having trouble sending your information. Your request did not go through. <br/>Please try submitting again or you may email us directly at <a href="mailto:insidesalestestleads@cinchhs.com">insidesalestestleads@cinchhs.com</a>.`,
            icon: 'pi pi-ban'
          };
          this.data.messagesToDisplay$.next([errorMessage]);
          this.isSubmitForm = false;
        }
      });
    } else {
      this.isSubmitForm = false;
    }
  }

  ngOnDestroy() {
    // cleanup
  }

}
